import { isFunction } from 'lodash'
export function createFilterContent () {
  return {
    functional: true,
    render (h, context) {
      const column = context.props.column
      const { key } = column || {}
      const filters = context.props.filters
      const filterMultiple = column.filterMultiple !== false
      const {
        filterSearchValue = '',
        filtersSearchPlaceholder,
        filteredValue
      } = context.props.store.states.filtersMap[key] || {}
      const filtersChange = context.props.store.filtersChange
      const resetFilter = context.props.store.resetFilter
      const filterSearchChange = context.props.store.filterSearchChange
      const onFilter = context.props.store.onFilter
      const updateFilters = context.props.store.updateFilters

      // 筛选条件
      const multipleFilters = () => {
        const val = filterSearchValue.trim()
        const data = val ? filters.filter(filter => filter.label.indexOf(val) > -1) : filters
        const GoupNode = filterMultiple ? 'el-checkbox-group' : 'el-radio-group'
        const Node = filterMultiple ? 'el-checkbox' : 'el-radio'
        return <div class="kye-table-v2-header-filter-checkbox">
          {
            data.length ? <GoupNode value={filteredValue} on-input={(val) => {
              filtersChange(val, column)
            }}>
              {
                data.map((filter, index) => {
                  return <Node
                    key={filter.value}
                    label={filter.value}>{ filter.label }
                  </Node>
                })
              }
            </GoupNode> : <div class="kye-table-v2-header-filter-checkbox-empty">无筛选数据</div>
          }
        </div>
      }
      const MultipleFiltersContent = multipleFilters()

      // 确认取消按钮
      const filterBtn = () => {
        const disabledReset = filterMultiple && Array.isArray(filteredValue) ? !filteredValue.length : !filteredValue
        const _resetFilter = () => {
          if (isFunction(column.resetFilter)) {
            column.resetFilter(context.props.store.states.filtersMap[key], column)
          } else {
            resetFilter(column)
          }
        }
        const _onFilter = () => {
          if (isFunction(column.onFilter)) {
            updateFilters(filteredValue, column)
            column.onFilter(context.props.store.states.filtersMap[key], column)
          } else {
            onFilter(filteredValue, column)
          }
          context.parent.$nextTick(() => {
            context.props.changeHeaderPopoverVisibleStatus(false)
          })
        }
        return <div class="kye-table-v2-header-filter-btn">
          <el-button size="mini" disabled={disabledReset} on-click={_resetFilter}>重置</el-button>
          <el-button size="mini" type="primary" on-click={_onFilter}>确定</el-button>
        </div>
      }
      const FilterBtn = filterBtn()

      // 搜索的输入框
      const filterSearch = () => {
        return <div class="kye-table-v2-header-filter-search">
          <el-input
            prefix-icon="el-icon-search"
            value={filterSearchValue}
            placeholder={filtersSearchPlaceholder}
            on-input={(val) => filterSearchChange(val, column)}
            clearable
          ></el-input>
        </div>
      }
      const FilterSearch = filterSearch()

      const wrapClass = {
        'kye-table-v2-header-filter-wrap': true,
      }

      // 渲染
      return <div class='kye-table-v2-header-filter-content'>
        {
          FilterSearch
        }
        <el-scrollbar wrapClass={wrapClass}>
          {
            MultipleFiltersContent
          }
        </el-scrollbar>
        {
          FilterBtn
        }
      </div>
    },
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/feature/filter/filter-content.js